import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Svg from '../svg/Svg';
import svgs from '../../../constants/svgs';

export const Select = ({
    className,
    desc,
    name,
    options = [],
    ...otherProps
}) => {
    return (
        <div className={cx('es-select__wrap', className)}>
            <label htmlFor={name}>{desc}</label>
            <select
                name={name}
                className="es-select"
                {...otherProps}
            >
                {options.map(o => {
                    const {
                        optionLabel,
                        ...other
                    } = o;

                    return <option {...other}>{optionLabel}</option>;
                })}
            </select>
            <Svg image={svgs.CARET} className="es-select__icon" />
        </div>
    );
};

Select.displayName = 'Select';

Select.propTypes = {
    desc: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.array
};
